import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MediaGalleryItem } from '../../../media-gallery/models/media-gallery-item';
import { TranslateHandler } from 'src/app/common/helpers/translate-handler';
import { SourceAPIService } from 'src/app/services/API/source-api.service';
import { LoadingService } from 'src/app/services/UI/loading.service';
import { GuidGenerator } from 'src/app/common/helpers/guid-generator';
import { ResponseModel } from 'src/app/common/models/ResponseModel';
import { CustomError } from 'src/app/common/helpers/custom-error';
import { DropMenu } from '../../../drop-menu/models/DropMenu';
import { DropMenuItem } from '../../../drop-menu/models/DropMenuItem';
import { DropMenuAction, DropMenuType, NotifierEvents, PopupViewMode } from 'src/app/common/enums/enums';
import { SourceBase } from 'src/app/common/models/source/source-base';
import { MessageDialogService } from '../../../message-dialog/services/message-dialog.service';
import { ComponentBase } from '../../../base/component-base';

@Component({
    selector: 'app-source-list',
    templateUrl: './source-list.component.html',
    styleUrls: ['./source-list.component.scss'],
    standalone: false
})
export class SourceListComponent extends ComponentBase implements OnInit {
  expectedUpdates = [NotifierEvents.RootMemberChanged];
  //Decorator Declarations
  @Input() data;
  @Output() onCompleted = new EventEmitter<any>();

  private _selectedSourceId: number;

  @Input()
  set selectedSourceId(value: number) {
    if (this._selectedSourceId !== value) {
      this._selectedSourceId = value;
      this.editedSourceId = value || null;
    }
  }

  get selectedSourceId(): number {
    return this._selectedSourceId;
  }


  //Variable Declarations
  searchPhrase: string = "";
  selectedMediaTitle: string;
  title: string;
  isDeleted: boolean;
  mediaItems: MediaGalleryItem[] = [];
  sources: SourceBase[];
  isStandAlone: boolean;
  editedSourceId: number | null = null;

  constructor(
    private loadingService: LoadingService,
    private sourceApiService: SourceAPIService,
    private translateHandler: TranslateHandler,
    private messageDialogService: MessageDialogService) {
    super();
  }

  ngOnInit(): void {
    const itemMenu = new DropMenu();
    itemMenu.type = DropMenuType.Inverted;
    itemMenu.menuItems = [{ action: DropMenuAction.Edit, isEnabled: true, isVisible: true }, { action: DropMenuAction.Delete, isEnabled: true, isVisible: true }]
    this.title = this.translateHandler.translate("lbl_source_list") ?? "";
    this.getSourceList();
    this.isStandAlone = true;
  }

  getSourceList() {
    let processId = GuidGenerator.generate();
    this.loadingService.show(processId);

    this.sourceApiService.getSourceListWithCount(1, 1).subscribe((response: ResponseModel<SourceBase[]>) => {
      this.sources = response.data;
      this.mediaItems = this.sources.map(i => ({
        id: 0, reference: i.id, caption: i.title, url: i?.mediaUrl ?? "/assets/images/icons/source.svg",
        isSelected: (i.id == 0), isEditEnable: (i.id == 0), dropMenu: this.createDropMenu(i)
      }));
      this.mediaItems.sort(this.compareSelected);
    }, (err) => {
      throw new CustomError("SourcesComponent => getSourceList() : " + err, 911, false);
    }).add(() => {
      this.loadingService.hide(processId);
    });

  }

  compareSelected(a: MediaGalleryItem, b: MediaGalleryItem) {
    if (a.isSelected == true) {
      return -1;
    }
    if (b.isSelected == true) {
      return 1;
    }
    return 0;
  }

  createDropMenu(ref: SourceBase) {
    let dropMenu = new DropMenu();
    dropMenu.type = 1;
    dropMenu.ref = ref;
    dropMenu.menuItems = [<DropMenuItem>{ action: DropMenuAction.Edit, isEnabled: true, isVisible: true },
    <DropMenuItem>{ action: DropMenuAction.Delete, isEnabled: true, isVisible: true }
    ];
    return dropMenu;
  }

  deleteSource(sourceId: number) {
    const processId = GuidGenerator.generate();
    this.loadingService.show(processId);

    this.sourceApiService.getReferenceCountToSource(sourceId).subscribe({
      next: (response: ResponseModel<number>) => {
        const message = this.translateHandler.translate("cnf_delete_source_confirmation_message") +
          this.translateHandler.translate("lnk_references", [response.data.toString()]);

        this.messageDialogService.openDeleteConfirmation(message).subscribe((confirmed: boolean) => {
          if (confirmed) {
            this.loadingService.show(processId);
            this.sourceApiService.deleteSource(sourceId).subscribe({
              next: (res: ResponseModel<boolean>) => {
                if (res.data) {
                  const deletedObj = this.mediaItems.find(s => s.reference === sourceId);
                  if (deletedObj) {
                    this.mediaItems.splice(this.mediaItems.indexOf(deletedObj), 1);
                  }
                  this.loadingService.hide(processId)
                  this.getSourceList();
                  this.data.editSourceId = 0;
                  this.onCompleted.emit(this.data);
                }
              },
              error: (err) => {
                throw new CustomError("SourcesComponent => deleteSource() : " + err, 911, false);
              }
            })
          }
        });
      },
      error: (err) => {
        throw new CustomError("SourcesComponent => getReferenceCountToSource() :" + err, 911, false);
      }
    }).add(() => this.loadingService.hide(processId));
  }

  setInability() {
    let isEnabled = this.mediaItems?.find(s => s.isSelected == true)?.isSelected ?? false;
    this.selectedMediaTitle = this.mediaItems?.find(s => s.isSelected === true)?.caption;
    return isEnabled;
  }

  getFilteredSources(): SourceBase[] {
    if (!this.searchPhrase || this.searchPhrase.trim() === '') {
      return this.sources ?? [];
    }
    const phrase = this.searchPhrase.toLowerCase();
    return (this.sources ?? []).filter(
      s => s.title?.toLowerCase().includes(phrase)
    );
  }
  editSource(source: SourceBase) {
    this.editedSourceId = source.id;
    this.data.editSourceId = source.id;
    this.onCompleted.emit(this.data);
  }

  notify() {
    this.title = this.translateHandler.translate("lbl_source_list") ?? "";
    this.getSourceList();
  }

}

